import { SetLiveEvent } from "models/event";
import { useHistory, useParams } from "react-router-dom";
import { EventCardBase } from "./EventCardBase";
import { Button } from "melodies-source/Button";

export interface ReportingEventCardProps {
  event: SetLiveEvent;
  showType: "upcoming" | "past";
  live?: boolean;
}

export const ReportingEventCard: React.FC<ReportingEventCardProps> = ({
  event,
  showType,
  live,
}) => {
  const { artistId } = useParams<{ artistId: string }>();
  const history = useHistory();

  const actions = (
    <Button
      variant="primary"
      onClick={() =>
        history.push(`/${artistId}/reporting/set-live/shows/${event.id}`)
      }
    >
      View Details
    </Button>
  );

  return (
    <EventCardBase
      event={event}
      showType={showType}
      live={live}
      actions={actions}
      hideCalendar
    />
  );
};
